import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import api from "@/lib/api";

export function PublicBlogIndex() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/blog").then(r => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ maxWidth: 980, margin: "0 auto", padding: "60px 24px 80px" }}>
      <Link to="/" className="font-mono" style={{ fontSize: 11, letterSpacing: ".15em", color: "var(--ink-mute)", textDecoration: "none" }}>← CANADAMRO EXCHANGE</Link>
      <h1 className="font-serif-display" style={{ fontSize: 48, fontWeight: 600, marginTop: 24, marginBottom: 6 }}>Blog</h1>
      <p className="font-mono" style={{ fontSize: 12, letterSpacing: ".1em", color: "var(--ink-mute)", marginBottom: 40 }}>
        Insights, releases, and notes from the platform team.
      </p>

      {loading && <p style={{ color: "var(--ink-mute)" }}>Loading…</p>}
      {!loading && posts.length === 0 && (
        <p data-testid="blog-empty" style={{ color: "var(--ink-mute)" }}>No posts yet — check back soon.</p>
      )}

      <div style={{ display: "grid", gap: 24 }}>
        {posts.map(p => (
          <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
                className="card"
                style={{ padding: 0, overflow: "hidden", textDecoration: "none", color: "inherit",
                         display: "grid", gridTemplateColumns: p.cover_image_url ? "240px 1fr" : "1fr", gap: 0 }}>
            {p.cover_image_url && (
              <div style={{ background: `url(${p.cover_image_url}) center/cover`, minHeight: 160 }} />
            )}
            <div style={{ padding: 22 }}>
              <div className="font-mono" style={{ fontSize: 10, letterSpacing: ".1em", color: "var(--amber-400)", marginBottom: 8 }}>
                {p.published_at ? new Date(p.published_at).toLocaleDateString() : ""} · {p.author_name}
              </div>
              <div className="font-serif-display" style={{ fontSize: 22, fontWeight: 600, marginBottom: 8 }}>{p.title}</div>
              <div style={{ fontSize: 14, color: "var(--ink-dim)" }}>{p.excerpt}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function PublicBlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/public/blog/${slug}`).then(r => setPost(r.data))
      .catch(e => setErr(e.response?.status === 404 ? "Post not found." : (e.response?.data?.detail || e.message)));
  }, [slug]);

  return (
    <div style={{ maxWidth: 760, margin: "0 auto", padding: "60px 24px 80px" }}>
      <Link to="/blog" className="font-mono" style={{ fontSize: 11, letterSpacing: ".15em", color: "var(--ink-mute)", textDecoration: "none" }}>← BLOG</Link>
      {err && <p data-testid="blog-error" style={{ color: "var(--ink-mute)", marginTop: 24 }}>{err}</p>}
      {post && (
        <>
          <h1 className="font-serif-display" data-testid={`blog-title-${post.slug}`}
              style={{ fontSize: 40, fontWeight: 600, marginTop: 24, marginBottom: 6, lineHeight: 1.15 }}>{post.title}</h1>
          <div className="font-mono" style={{ fontSize: 11, letterSpacing: ".1em", color: "var(--ink-mute)", marginBottom: 32 }}>
            {post.published_at ? new Date(post.published_at).toLocaleDateString() : ""} · {post.author_name}
          </div>
          {post.cover_image_url && (
            <img src={post.cover_image_url} alt="" style={{ width: "100%", borderRadius: 6, marginBottom: 32 }} />
          )}
          <article className="legal-body"><ReactMarkdown>{post.body_markdown || ""}</ReactMarkdown></article>
        </>
      )}
    </div>
  );
}
